import { FlexBox, Skeleton } from '@dixa/lib-shared-habla';

import styles from './teamTableLoading.module.scss';

type TeamTableLoadingProps = {
  count?: number;
};

/** Placeholder rows component for the team table loading state. */
export const TeamTableLoading = ({ count = 10 }: TeamTableLoadingProps) => {
  return (
    <>
      {Array.from(Array(count)).map((_, index) => (
        <FlexBox
          key={index}
          alignItems="center"
          justifyContent="space-between"
          padding="100 400"
          className={styles.row}
        >
          <FlexBox gap="300" alignItems="center">
            <Skeleton width="24px" height="24px" />
            <Skeleton width="40px" height="40px" borderRadius="100" />
            <Skeleton width="180px" height="16px" />
          </FlexBox>
          <FlexBox gap="200" alignItems="center">
            {Array.from({ length: 8 }).map((_, idx) => (
              <Skeleton
                key={idx}
                width="24px"
                height="24px"
                borderRadius="100"
              />
            ))}
          </FlexBox>
        </FlexBox>
      ))}
    </>
  );
};
